<template>
    <div class="payable-receivable-totalization-wrap">
        <div class="payable-receivable-totalization-list">
            <div v-for="item in displayedTotalizations" :key="item.title" class="payable-receivable-totalization-item">
                <div class="payable-receivable-totalization-pill" :class="variantOf(item)">
                    <span class="payable-receivable-totalization-title">{{ item.title }}</span>
                    <span>{{ item.value | currency }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    normalizePayableReceivableTitle,
} from "../../services/payableReceivableList.config";

export default {
    name: "PayableReceivableTotalization",
    props: {
        totalizations: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            variantByClass: {
                receivable: "totalization payable-receivable-totalization-variant-receivable",
                received: "totalization payable-receivable-totalization-variant-received",
                payable: "totalization payable-receivable-totalization-variant-payable",
                paid: "totalization payable-receivable-totalization-variant-paid",
            },
            variantByTitle: {
                "a-receber": "receivable",
                "recebido": "received",
                "a-pagar": "payable",
                "pago": "paid",
            },
            defaultVariant: "payable-receivable-totalization-variant-default",
        };
    },
    computed: {
        displayedTotalizations() {
            return (this.totalizations || []).filter((item) => !!this.resolveVariantKey(item));
        },
    },
    methods: {
        normalizeTitle(title) {
            return normalizePayableReceivableTitle(title);
        },
        resolveVariantKey(item) {
            const classCss = item?.classCss;
            if (classCss && this.variantByClass[classCss]) {
                return classCss;
            }

            const normalizedTitle = this.normalizeTitle(item?.title);
            return this.variantByTitle[normalizedTitle] || "";
        },
        variantOf(item) {
            const variantKey = this.resolveVariantKey(item);
            if (!variantKey) {
                return this.defaultVariant;
            }

            return this.variantByClass[variantKey] || this.defaultVariant;
        },
    },
};
</script>

<style scoped>
.payable-receivable-totalization-wrap {
    margin: 0 0 20px;
}

.payable-receivable-totalization-list {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

.payable-receivable-totalization-item {
    display: inline-block;
}

.payable-receivable-totalization-pill {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    border-radius: 999px;
    border: 1px solid var(--border-color);
    background: var(--bg-base);
    color: var(--text-secondary);
    font-size: 13px;
    line-height: 1;
}

.payable-receivable-totalization-title {
    font-weight: 500;
}

.payable-receivable-totalization-variant-default {
    border-color: var(--border-color);
    background: var(--bg-base);
    color: var(--text-secondary);
}

.payable-receivable-totalization-variant-receivable {
    color: var(--pr-badge-receivable-text);
    border: 1px solid var(--pr-badge-receivable-border) !important;
    background-color: var(--pr-badge-receivable-bg);
}

.payable-receivable-totalization-variant-received {
    background: var(--pr-badge-received-bg);
    border: 1px solid var(--pr-badge-received-border) !important;
    color: var(--pr-badge-received-text);
}

.payable-receivable-totalization-variant-payable {
    background: var(--pr-badge-payable-bg);
    border: 1px solid var(--pr-badge-payable-border) !important;
    color: var(--pr-badge-payable-text);
}

.payable-receivable-totalization-variant-paid {
    background: var(--pr-badge-paid-bg);
    border: 1px solid var(--pr-badge-paid-border) !important;
    color: var(--pr-badge-paid-text);
}

.dark-theme .totalization {
    background-color: transparent !important;
}
</style>
